module.exports = __webpack_public_path__ + "img/avatar8.fe20c011.png";